module.exports = __webpack_public_path__ + "static/media/post-img2.79ffa39c.jpg";